import Swal from "sweetalert2";

const handleAddToCartButton = (isAddToCart, setIsAddToCart) => {

    setIsAddToCart(true);

    // i put ! before the favorite variable because useState in react is async so, we need to handel it 
    if (!isAddToCart) {

        Swal.fire({
            icon: 'success',
            title: 'Product successfully added to cart. Enjoy!',
        })

    } else {

        Swal.fire({
            icon: 'warning',
            title: 'Product already in cart. Happy shopping!',
        })

    }
}

export const handelAnimationCartBtn = (e, isAddToCart, setIsAddToCart, showSuccess) => {

    const targetElement = e.target.closest(".cart-button");

    if (targetElement && !targetElement.classList.contains("loading")) {

        const toggle = e.target.tagName === "SPAN";

        const elementToToggle = toggle ? targetElement : e.target;

        elementToToggle.classList.add("loading");

        setTimeout(() => {

            elementToToggle.classList.remove("loading");

        }, 3700);
    }

    handleAddToCartButton(isAddToCart, setIsAddToCart, showSuccess);

}